<div class="fullscreen-div">
  <router-outlet></router-outlet>
</div>
